/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../widgetProperties/WidgetPropertiesProvider'
], function(WidgetPropertiesProvider) {

	class TabWidgetPropertiesProvider extends WidgetPropertiesProvider {

		constructor(options) {
			super(options);
			// Set the type to the TabWidget if we are not a top level tab container.
			if ( options.content.getContainer() ) {
				this.type = 'TabWidget';
			}

		}

		getWidgetModel() {
			// Change to the layout model since we don't have a widget model in the tabs
			return this._features['Models.internal'].getLayoutModel();
		}

		getContributionSpec() {

			// The WidgetPropertiesProvider.getContributionSpec () will throw a null exception for the top level tab layout.
			// Simply return an empty spec if it is not a tab widget
			return (this.type === 'TabWidget') ?  super.getContributionSpec(): {};
		}
	}

	return TabWidgetPropertiesProvider;

});
